// Generated by CoffeeScript 2.7.0
var TimePicker;

import TimePickerMixin from "./time_picker_mixin.js";

export default TimePicker = Vue.extend({
  mixins: [TimePickerMixin],
  data: function() {
    return {
      // 'time' | 'hour' | 'minute'
      viewMode: 'time'
    };
  },
  template: `<div class="timepicker">
  <div class="timepicker-time-mode" v-show='viewMode == "time"'>
    <div class="timepicker-hour">
      <div class="timepicker-title">小时</div>
      <div class="number-picker">
        <div class="increase-ctrl" @click='increaseHour(1)'>
          <i class="slp-chevron-right"></i>
        </div>
        <div class="number-picker-value" v-if='deviceSupportTouch' @click='setViewMode("hour")'>{{ hour.zeroFill() }}</div>
        <input class="number-picker-value"
               type='number'
               @input='_updateHour'
               v-else
               :value='hour.zeroFill()' />
        <div class="decrease-ctrl" @click='increaseHour(-1)'>
          <i class="slp-chevron-right"></i>
        </div>
      </div>
    </div>
    <div class="timepicker-divider">
      <i class="slp-colon"></i>
    </div>
    <div class="timepicker-minute">
      <div class="timepicker-title">分钟</div>
      <div class="number-picker">
        <div class="increase-ctrl" @click='increaseMinute(1)'>
          <i class="slp-chevron-right"></i>
        </div>
        <div class="number-picker-value" v-if='deviceSupportTouch' @click='setViewMode("minute")'>{{ minute.zeroFill() }}</div>
        <input class="number-picker-value"
               type='number'
               @input='_updateMinute'
               v-else
               :value='minute.zeroFill()' />
        <div class="decrease-ctrl" @click='increaseMinute(-1)'>
          <i class="slp-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="picker-view" v-show='viewMode == "hour"'>
    <div class="picker-row" v-for='(r, index) in displayRange' :key='index'>
      <div class="picker-item"
           v-for='h in r'
           :key='h'
           @click='hourPicked(h)'
           :class='{ active: hour === h }'>
        <div class="picker-value">{{ h.zeroFill() }}</div>
      </div>
    </div>
  </div>
  <div class="picker-view minute-picker" v-show="viewMode == 'minute'">
    <div class="picker-row" v-for='(r, index) in displayRange' :key='index'>
      <div class="picker-item"
           v-for='m in r'
           :key='m'
           :class='{ active: m === minute }'
           @click='minutePicked(m)'>
        <div class="picker-value">
          {{ m.zeroFill() }}
        </div>
      </div>
    </div>
  </div>
</div>`,
  computed: {
    deviceSupportTouch: function() {
      return 'ontouchstart' in window;
    },
    displayRange: function() {
      switch (this.viewMode) {
        case 'hour':
          return (function() {
            var results = [];
            for (var i = 0; i <= 23; i++){ results.push(i); }
            return results;
          }).apply(this).groupByLength(6);
        case 'minute':
          return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function(item) {
            return item * 5;
          }).groupByLength(4);
        default:
          return [];
      }
    }
  },
  methods: {
    setTime: function(time = new Date()) {
      return this.time = {
        hour: time.getHours(),
        minute: time.getMinutes()
      };
    },
    increaseHour: function(delta) {
      return this.hour = (this.hour + delta + 24) % 24;
    },
    increaseMinute: function(delta) {
      return this.minute = (this.minute + delta + 60) % 60;
    },
    hourPicked: function(hour) {
      this.updateHour(hour);
      return this.setViewMode('time');
    },
    minutePicked: function(minute) {
      this.updateMinute(minute);
      return this.setViewMode('time');
    },
    updateHour: function(hour) {
      return this.hour = hour;
    },
    updateMinute: function(minute) {
      return this.minute = minute;
    },
    setViewMode: function(mode) {
      return this.viewMode = mode;
    },
    _updateMinute: function(event) {
      var value;
      value = parseInt(event.target.value) || 0;
      if (this.minute === value) {
        this.minute = 60;
      }
      this.minute = value;
      if (value >= 60) {
        return this.minute = 59;
      } else if (value < 0) {
        return this.minute = 0;
      }
    },
    _updateHour: function(event) {
      var value;
      value = parseInt(event.target.value || '0') || 0;
      // make sure hour changed to refresh view
      if (this.hour === value) {
        this.hour = 24;
      }
      this.hour = value;
      if (value >= 24) {
        return this.hour = 23;
      } else if (value < 0) {
        return this.hour = 0;
      }
    }
  }
});
